import React from 'react';
import ClientManagementView from '../../components/crm/client-management/ClientManagementView';

const ClientManagementPage: React.FC = () => {
  return <ClientManagementView />;
};

export default ClientManagementPage;
